module.exports = __webpack_public_path__ + "static/media/card-front.4fcf21e9.png";